import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'claims.list.title',
        defaultMessage: 'List claims'
    },
    VISIBLE_COLUMNS: {
        id: 'claims.list.label.visibleColumns',
        defaultMessage: 'Visible columns'
    },
    TABLE_TICKET_NUMBER: {
        id: 'claims.list.table.ticketNo',
        defaultMessage: 'Ticket No.'
    },
    TABLE_ORDER_CREATION_TIME: {
        id: 'claims.list.table.creationDate',
        defaultMessage: 'Creation Date'
    },
    TABLE_CLIENT_ID: {
        id: 'claims.list.table.clientId',
        defaultMessage: 'Client ID'
    },
    TABLE_DEALER_NUMBER: {
        id: 'claims.list.table.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    TABLE_DEALER_NAME: {
        id: 'claims.list.table.dealerName',
        defaultMessage: 'Dealer Name'
    },
    TABLE_FORM_TYPE: {
        id: 'claims.list.table.formType',
        defaultMessage: 'Type of Form'
    },
    TABLE_STATUS: {
        id: 'claims.list.table.status',
        defaultMessage: 'Status'
    },
    TABLE_LAST_STATUS_DATE: {
        id: 'claims.list.table.lastStatusDate',
        defaultMessage: 'Last Status Date'
    },
    TABLE_LAST_EDITOR: {
        id: 'claims.list.table.lastEditor',
        defaultMessage: 'Last Editor'
    },
    TABLE_CREATED_BY: {
        id: 'claims.list.table.createdBy',
        defaultMessage: 'Created by (IPN)'
    },
    TABLE_REG_DIR: {
        id: 'claims.list.table.regDir',
        defaultMessage: 'Region'
    },
    TABLE_CLAIM_RELATED: {
        id: 'claims.list.table.claimRelatedNo',
        defaultMessage: 'Claim Related No.'
    },
    TABLE_INVOICE: {
        id: 'claims.list.table.invoiceNo',
        defaultMessage: 'Invoice No.'
    },
    TABLE_MISSING_PACKAGE: {
        id: 'claims.list.table.missingPackageNo',
        defaultMessage: 'Missing Package No.'
    },
    TABLE_WRONG_DESTINATION: {
        id: 'claims.list.table.wrongDestinationNo',
        defaultMessage: 'Package Destination Error No.'
    },
    TABLE_PART_NO: {
        id: 'claims.list.table.partNo',
        defaultMessage: 'Part No.'
    },
    TABLE_SUPPLIER: {
      id: 'claims.ticket.table.supplier',
      defaultMessage: 'Supplier'
    },
    TABLE_PACKAGE_NO: {
        id: 'claims.list.table.packageNo',
        defaultMessage: 'Package No.'
    },
    TABLE_TAKING_BACK: {
        id: 'claims.list.table.takingBackNo',
        defaultMessage: 'Taking Back No.'
    },
    TABLE_CONTAINER: {
        id: 'claims.list.table.containerNo',
        defaultMessage: 'Container No.'
    },
    TABLE_CLIENT_SOLUTION_PILOT: {
        id: 'claims.list.table.clientSolutionPilot',
        defaultMessage: 'Client Solution Pilot'
    },
});

export default messages;
